import {BoxPosition, Pallet} from '../generated/model/models'

export function rotateLayer180 (pallet: Pallet, boxPositions: BoxPosition[]): BoxPosition[] {
  if (!pallet.length || !pallet.width) {
    return boxPositions
  }

  // deep clone the argument array
  const newBoxPositions = boxPositions.map(boxPos => Object.assign({}, boxPos))
  const overhangL = pallet.overhangL || 0
  const overhangR = pallet.overhangR || 0
  const overhangT = pallet.overhangT || 0
  const overhangB = pallet.overhangB || 0

  const totalPalletLength = pallet.length + overhangL + overhangR
  const totalPalletWidth = pallet.width + overhangT + overhangB
  const halfPalletLength = Math.floor(totalPalletLength / 2 + 0.5)
  const halfPalletWidth = Math.floor(totalPalletWidth / 2 + 0.5)

  newBoxPositions.forEach((element: BoxPosition) => {
    // shift origo to the pattern midpoint
    let x = element.x! + overhangL - halfPalletLength
    let y = element.y! + overhangT - halfPalletWidth

    // move box to opposite corner of pattern
    x = -x
    y = -y

    // rotate box 180 degrees
    element.rotation = (element.rotation! + 180) % 360

    // reset origo to pallet upper left corner
    x = x - overhangL + halfPalletLength
    y = y - overhangT + halfPalletWidth
    element.x = x
    element.y = y
  })
  return newBoxPositions
}

export function mirrorLayer (pallet: Pallet, boxPositions: BoxPosition[], mirrorByYAxis: boolean): BoxPosition[] {
  if (!pallet.length || !pallet.width) {
    return boxPositions
  }

  // deep clone the argument array
  const newBoxPositions = boxPositions.map(boxPos => Object.assign({}, boxPos))
  const overhangL = pallet.overhangL || 0
  const overhangR = pallet.overhangR || 0
  const overhangT = pallet.overhangT || 0
  const overhangB = pallet.overhangB || 0

  const totalPalletLength = pallet.length + overhangL + overhangR
  const totalPalletWidth = pallet.width + overhangT + overhangB

  if (mirrorByYAxis) {
    newBoxPositions.forEach((element: BoxPosition) => {
      element.rotation = element.rotation! % 180 === 0 ? (element.rotation! + 180) % 360 : element.rotation
      element.x = totalPalletLength - element.x!
    })
  } else {
    newBoxPositions.forEach((element: BoxPosition) => {
      element.rotation = element.rotation! % 180 === 90 ? (element.rotation! + 180) % 360 : element.rotation
      element.y = totalPalletWidth - element.y!
    })
  }
  return newBoxPositions
}
